import { __spreadArrays } from "tslib";
export var getMessageFromState = function (state, messageId) {
    return state.messageList.find(function (m) { return m.MessageId === messageId; });
};
export var replaceMessageInState = function (state, oldMessage, newMessage) {
    var messageList = __spreadArrays(state.messageList);
    if (oldMessage) {
        var messageIndex = state.messageList.indexOf(oldMessage);
        messageList.splice(messageIndex, 1, newMessage);
    }
    return messageList;
};
export var removeMessageFromState = function (state, messageId) {
    return state.messageList.filter(function (m) { return m.MessageId !== messageId; });
};
export var mergeMessageArrays = function (existingList, newItems) {
    var existingMessageIds = existingList.map(function (l) { return l.MessageId; });
    var newMessages = newItems.filter(function (m) { return existingMessageIds.indexOf(m.MessageId) === -1; });
    return __spreadArrays(existingList, newMessages);
};
